import React from 'react';
import { ArrowLeft } from 'lucide-react';
interface SetupLayoutProps {
  step: number;
  onBack: () => void;
  children: React.ReactNode;
}
export function SetupLayout({
  step,
  onBack,
  children
}: SetupLayoutProps) {
  return <main className="min-h-screen w-full bg-background md:bg-secondary flex flex-col items-center justify-center p-0 md:p-6 animate-fadeInUp" data-id="element-306">
      <div className="w-full max-w-[520px] min-h-screen md:min-h-[600px] bg-background md:rounded-card md:shadow-elevated flex flex-col relative overflow-hidden" data-id="element-307">
        {/* Header & Progress */}
        <div className="w-full px-6 pt-6 pb-2 md:pt-8" data-id="element-308">
          <div className="flex items-center mb-4" data-id="element-309">
            <button onClick={onBack} className="text-text-secondary hover:text-text-primary transition-colors mr-4" aria-label="Go back" data-id="element-310">
              <ArrowLeft size={24} data-id="element-311" />
            </button>
            <div className="flex-1 h-[6px] bg-border rounded-pill overflow-hidden" data-id="element-312">
              <div className="h-full bg-primary rounded-pill transition-all duration-400 ease-out" style={{
              width: `${step / 4 * 100}%`
            }} data-id="element-313" />
            </div>
          </div>
          <div className="text-[12px] text-text-secondary text-center font-medium" data-id="element-314">
            Step {step} of 4
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 overflow-y-auto p-6 pt-2 flex flex-col" data-id="element-315">
          {children}
        </div>
      </div>
    </main>;
}